module.exports = __webpack_public_path__ + "static/media/Logo.6212be36.png";